import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import type { PageQuery, PagedResult } from '@domain/models/paged-result.model';
import type { UserTag } from '@domain/models/user.model';
import { UserTagRepository } from '@domain/repositories/user-tag.repository';

import type { ApiPagedResponse, UserTagDto } from '@data/dto/api.dto';
import { mapPagedUserTags, toPageParams } from '@data/mappers/user.mapper';

@Injectable()
export class UserTagApiRepository extends UserTagRepository {
  private readonly http = inject(HttpClient);
  private readonly path = 'api/user-tags';

  list(query: PageQuery): Observable<PagedResult<UserTag>> {
    const params = new HttpParams({
      fromObject: toPageParams(query) as Record<string, string | number>,
    });

    return this.http
      .get<ApiPagedResponse<UserTagDto>>(this.path, { params })
      .pipe(map(mapPagedUserTags));
  }

  create(name: string, isDefault: boolean): Observable<number> {
    return this.http.post<number>(this.path, { name, isDefault });
  }

  update(id: number, name: string, isDefault: boolean): Observable<void> {
    return this.http.put<void>(`${this.path}/${id}`, { name, isDefault });
  }
}
